import { BehaviorSubject, Observable } from 'rxjs';

export class ObservableList<T> {
    private items: T[] = [];
    private readonly subject: BehaviorSubject<T[]> = new BehaviorSubject<T[]>(this.items);

    public asObservable(): Observable<T[]> {
        return this.subject.asObservable();
    }

    public push(item: T): number {
        this.items = [...this.items];
        const result = this.items.push(item);
        this.subject.next(this.items);
        return result;
    }

    public clear(): void {
        this.items = [];
        this.subject.next(this.items);
    }
}
